export default __webpack_public_path__ + "media/images/deco01-18fe56de309d3d95237c5e1e75704d38.png";